var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    ref: "pno0",
    attrs: {
      "maxlength": "5",
      "outlined": _vm.outlined,
      "placeholder": _vm.placeholder,
      "hide-details": _vm.hideDetails,
      "dense": _vm.dense
    },
    on: {
      "input": function input(v) {
        return (v === null || v === void 0 ? void 0 : v.length) == 5 ? _this.$refs.pno1.$refs.input.focus() : false;
      }
    },
    model: {
      value: _vm.pnos[0],
      callback: function callback($$v) {
        _vm.$set(_vm.pnos, 0, $$v);
      },
      expression: "pnos[0]"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('span', [_vm._v("-")])]), _c('v-flex', [_c('v-text-field', {
    ref: "pno1",
    attrs: {
      "maxlength": "5",
      "outlined": _vm.outlined,
      "placeholder": _vm.placeholder,
      "hide-details": _vm.hideDetails,
      "dense": _vm.dense
    },
    on: {
      "input": function input(v) {
        return (v === null || v === void 0 ? void 0 : v.length) == 5 ? _this.$refs.pno2.$refs.input.focus() : false;
      }
    },
    model: {
      value: _vm.pnos[1],
      callback: function callback($$v) {
        _vm.$set(_vm.pnos, 1, $$v);
      },
      expression: "pnos[1]"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('span', [_vm._v("-")])]), _c('v-flex', [_c('v-text-field', {
    ref: "pno2",
    attrs: {
      "maxlength": "5",
      "outlined": _vm.outlined,
      "placeholder": _vm.placeholder,
      "hide-details": _vm.hideDetails,
      "dense": _vm.dense
    },
    on: {
      "input": function input(v) {
        return (v === null || v === void 0 ? void 0 : v.length) == 5 ? _this.$refs.pno3.$refs.input.focus() : false;
      }
    },
    model: {
      value: _vm.pnos[2],
      callback: function callback($$v) {
        _vm.$set(_vm.pnos, 2, $$v);
      },
      expression: "pnos[2]"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('span', [_vm._v("-")])]), _c('v-flex', [_c('v-text-field', {
    ref: "pno3",
    attrs: {
      "maxlength": "5",
      "outlined": _vm.outlined,
      "placeholder": _vm.placeholder,
      "hide-details": _vm.hideDetails,
      "dense": _vm.dense
    },
    model: {
      value: _vm.pnos[3],
      callback: function callback($$v) {
        _vm.$set(_vm.pnos, 3, $$v);
      },
      expression: "pnos[3]"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }